import { FieldErrors, UseFormRegister } from "react-hook-form";
import Input from "../../../shared/input";
import { ISignUpUser } from "../../../interfaces/auth/ISignUpUser";

const SignupStep2 = ({
	register,
	errors,
	password
}:{
	register: UseFormRegister<ISignUpUser>,
	errors: FieldErrors<ISignUpUser>
	password: string
}) => {
	return (
		<>
		<p className="text-[#0E0F0C] font-normal my-2 text-base">
          Account
        </p>
		<Input
		  containerStyle="mb-1"
		  labelStyle="text-sm text-saloon-details"
		  inputStyle="rounded-lg"
          placeholder=""
          label="Username"
          register={register("username", {
            required: {
              message: "Username is required",
              value: true,
            },
            validate: (value: string) =>
              !!value.trim() || "Username is required",
          })}
          error={errors?.username?.message}
        />
        <Input
		  type='password'
		  containerStyle="mb-1"
		  labelStyle="text-sm text-saloon-details"
		  inputStyle="rounded-lg"
          placeholder=""
          label="Your password"
          register={register("password", {
            required: {
              message: "Your password is required",
              value: true,
            },
          })}
          error={errors?.password?.message}
        />
		<Input
		  type='password'
		  containerStyle="mb-1"
		  labelStyle="text-sm text-saloon-details"
		  inputStyle="rounded-lg"
          placeholder=""
          label="Repeat Password"
          register={register("repeatPassword", {
            required: {
              message: "Repeat Password is required",
              value: true,
            },
            validate: (value) => (value === password) || "Passwords do not match"
          })}
          error={errors.repeatPassword?.message}
        />
		<p className="text-[#0E0F0C] font-normal my-2 text-base">Profile</p>
		<Input
		  containerStyle="mb-1"
		  labelStyle="text-sm text-saloon-details"
		  inputStyle="rounded-lg"
          placeholder=""
          label="Hotel Address"
          register={register("hotelAddress", {
            required: {
              message: "Hotel address is required",
              value: true,
            },
            validate: (value: string) =>
              !!value.trim() || "Hotel Address is required",
          })}
          error={errors.hotelAddress?.message}
        />
		<Input
		  containerStyle="mb-1"
		  labelStyle="text-sm text-saloon-details"
		  inputStyle="rounded-lg"
          placeholder=""
          label="General Hotel Email"
          register={register("hotelEmail", {
            required: {
              message: "Hotel email is required",
              value: true,
            },
            validate: (value: string) =>
              !!value.trim() || "Hotel email is required",
          })}
          error={errors.hotelEmail?.message}
        />
		<Input
		  containerStyle="mb-1"
		  labelStyle="text-sm text-saloon-details"
		  inputStyle="rounded-lg"
          placeholder=""
          label="Phone number"
          register={register("hotelPhoneNumber", {
            required: {
              message: "Phone number is required",
              value: true,
            },
            validate: (value: string) =>
              !!value.trim() || "Phone number is required",
          })}
          error={errors.hotelPhoneNumber?.message}
        />
		</>
	)
}

export default SignupStep2;